/* eslint-disable max-len */
import cx from 'classnames';
import { FC, ReactElement } from 'react';

import classes from './CheckboxNew.module.scss';
import { CheckboxNewProps } from './CheckboxNew.types';

export const CheckboxNew: FC<CheckboxNewProps> = ({
  name,
  value,
  children,
  isDisabled,
  onChange,
  onKeyDown,
  isSelected = false,
  tabIndex,
  className,
  isShowMarker = true,
}): ReactElement => (
  <label
    className={cx(
      classes.checkbox,
      { [classes['checkbox--checked']]: isSelected },
      { [classes['checkbox--disabled']]: isDisabled },
      className,
    )}
  >
    <input
      tabIndex={tabIndex}
      type="checkbox"
      name={name}
      value={value}
      disabled={isDisabled}
      onChange={onChange}
      onKeyDown={onKeyDown}
      checked={isSelected}
      className={cx(classes.checkbox__input)}
    />
    <span
      className={cx(classes.checkbox__marker, {
        [classes['checkbox__marker--hide']]: !isShowMarker,
      })}
    >
      {isSelected && (
        <svg
          className={cx(classes.checkbox__icon)}
          width="11"
          height="8"
          viewBox="0 0 11 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.25865 3.40783C1.93365 3.08283 1.40615 3.08283 1.08031 3.40783C0.754479 3.73366 0.754479 4.26116 1.08031 4.58699L4.16865 7.67533L9.76198 2.08949C10.0878 1.76449 10.0878 1.23699 9.76281 0.911159C9.43698 0.586159 8.90948 0.585326 8.58365 0.910326L4.16948 5.31866L2.25865 3.40783Z"
            fill="white"
          />
        </svg>
      )}
    </span>
    {children && (
      <span className={cx(classes.checkbox__content)}>{children}</span>
    )}
  </label>
);
